import DADOS_SIM from '../../consts/consts';

const cotacaoValues = DADOS_SIM.DADOS_COTACAO;
/**
 * Types
 */

export const TipoSimulacaoTypes = {
    SET_TIPO_SIMULACAO: 'home/SET_TIPO_SIMULACAO',
    SET_CODIGO_ACESSO: 'home/SET_CODIGO_ACESSO',
    RESET: 'home/RESET'
};

/**
 * Reducer
 */

export function tipoSimulacaoReducer(state = [], action) {
    switch (action.type) {
        case TipoSimulacaoTypes.RESET: {
            return {};
        }
        case TipoSimulacaoTypes.SET_TIPO_SIMULACAO: {
            return {
                ...state,
                [cotacaoValues.ID_TIPO_COTACAO]: action.payload[cotacaoValues.ID_TIPO_COTACAO]
            };
        }
        case TipoSimulacaoTypes.SET_CODIGO_ACESSO:
            return {
                ...state,
                [cotacaoValues.CODIGO_ACESSO]: action.payload[cotacaoValues.CODIGO_ACESSO]
            };
        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    setTipoSimulacao: (tipoSimulacao) => ({
        type: TipoSimulacaoTypes.SET_TIPO_SIMULACAO,
        payload: { [cotacaoValues.ID_TIPO_COTACAO]: tipoSimulacao }
    }),

    setCodigoAcesso: (codigoAcesso) => ({
        type: TipoSimulacaoTypes.SET_CODIGO_ACESSO,
        payload: { [cotacaoValues.CODIGO_ACESSO]: codigoAcesso }
    }),
    reset: () => ({
        type: TipoSimulacaoTypes.RESET
    })
};
